/**
 * @generated SignedSource<<c80b6b1cf7440eb2fca4e0fe42200e84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ConsentStatus = "ACCEPTED" | "DECLINED" | "EXPIRED" | "NEW" | "RETIRED";
export type BarcBannerQuery$variables = {};
export type BarcBannerQuery$data = {
  readonly cookies: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly consent: {
          readonly status: ConsentStatus;
        } | null;
        readonly cookieId: string;
      };
    }>;
  } | null;
};
export type BarcBannerQuery = {
  response: BarcBannerQuery$data;
  variables: BarcBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cookieId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "CookieConsent",
  "kind": "LinkedField",
  "name": "consent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BarcBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CookieConnection",
        "kind": "LinkedField",
        "name": "cookies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CookieEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Cookie",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BarcBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CookieConnection",
        "kind": "LinkedField",
        "name": "cookies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CookieEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Cookie",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2b040d08edd67ff829ce99ff0c4d5769",
    "id": null,
    "metadata": {},
    "name": "BarcBannerQuery",
    "operationKind": "query",
    "text": "query BarcBannerQuery {\n  cookies {\n    edges {\n      node {\n        cookieId\n        consent {\n          status\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "398d5e2c1bfcc13bb9bb504fda89af16";

export default node;
